import { replaceRouterState } from '@namespace/router';

// same event can appear on a page twice in different components
const findDataRoleDeepSelector = (el) => {
  const result = [];

  for (let parent = el; parent != null; parent = parent.parentElement) {
    if (parent.dataset.role) {
      result.unshift(parent.dataset.role);
    }
  }

  return result.map((dataRole) => `[data-role="${dataRole}"]`).join(' ');
};

export const markHistoryFrameWithScrollToEl = (e, componentType) => {
  const selector = findDataRoleDeepSelector(e.currentTarget);

  // mark current history frame with scrollToElSelector to scroll to
  replaceRouterState({
    scrollToElSelector: selector,
    scrollToY: window.scrollY,
    scrollToComponentType: componentType
  });
};
